/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import ConfigProvider from '../config-provider';
import { obj } from '../util';

const customCache = new Set();
/**
 * Icon
 */
class Shell extends Component {
  static propTypes = {
    prefix: PropTypes.string,
    rtl: PropTypes.bool,
    /**
     * 指定显示哪种图标
     */
    type: PropTypes.string,
    /**
     * 指定图标大小
     */
    size: PropTypes.oneOf(['xs', 'small', 'medium', 'large', 'xl', 'xxl', 'xxxl']),
    className: PropTypes.string,
  };

  static defaultProps = {
    prefix: 'next-',
    size: 'medium',
  };

  render() {
    /* eslint-disable no-unused-vars */
    const { prefix, type, size, className, rtl, children } = this.props;
    const other = obj.pickOthers(Shell.propTypes, this.props);
    const classes = cls({
      [`${prefix}icon`]: true,
      [`${prefix}icon-${type}`]: !!type,
      [`${prefix}${size}`]: !!size,
      [className]: !!className,
    });

    if (
      rtl &&
      [
        'chevron-left',
        'chevron-right',
        'chevrons-left',
        'chevrons-right',
        'arrows-swtich-horizontal',
        'arrows-swtich-vertical',
        'arrows-long-down',
        'arrows-long-up',
      ].indexOf(type) !== -1
    ) {
      other.dir = 'rtl';
    }

    return (
      <i {...other} className={classes}>
        {children}
      </i>
    );
  }
}

function create(options = {}) {
  class Iconfont extends React.Component {
    static displayName = 'Iconfont';

    constructor(props) {
      super(props);
      const {
        scriptUrl = props.scriptUrl || '//at.alicdn.com/t/font_1310450_bu1mdyfarej.js',
      } = options;

      /**
       * DOM API required.
       * Make sure in browser environment.
       * The Custom Icon will create a <script/>
       * that loads SVG symbols and insert the SVG Element into the document body.
       */
      if (
        typeof document !== 'undefined' &&
        typeof window !== 'undefined' &&
        typeof document.createElement === 'function' &&
        typeof scriptUrl === 'string' &&
        scriptUrl.length &&
        !customCache.has(scriptUrl)
      ) {
        const script = document.createElement('script');
        script.setAttribute('src', scriptUrl);
        script.setAttribute('data-namespace', scriptUrl);
        customCache.add(scriptUrl);
        document.body.appendChild(script);
      }
    }

    render() {
      const { symbolPrefix } = options;
      const { type, children, ...restProps } = this.props;
      let content = null;
      if (type) {
        content = <use xlinkHref={`#${symbolPrefix}${type}`} />;
      }
      return (
        <Shell
          type={type}
          {...restProps}
          className={cls({
            [restProps.className]: !!restProps.className,
          })}
        >
          <svg viewBox="0 0 1024 1024">{content}</svg>
        </Shell>
      );
    }
  }

  return Iconfont;
}

const Icon = create({
  symbolPrefix: 'at-',
});

Icon._typeMark = 'icon';

Icon.createFromIconfont = create;

export default ConfigProvider.config(Icon);
